import Navigation from "./Main/Navigation.main";

const NavigationBackButton = {

    render(level, caption) {
        const item = this.prepareItem(level);
        const anchor = this.prepareAnchor(caption);
        anchor.appendTo(item);
        return item;
    },

    prepareItem(level) {
        const li = $('<li class="item back"></li>');

        li.click((evt) => {
            evt.stopPropagation();
            const level = $(evt.currentTarget).attr('level');
            Navigation.closeFrom(level);
        })

        return $(li.clone(true)).attr('level', level);
    },

    prepareAnchor(caption) {
        const a = $('<a href="#" icon="chevron_left"></a>')

        a.click((evt) => {
            evt.preventDefault();
        })

        return $(a.clone(true)).text(caption);
    },

}

export default NavigationBackButton;